import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { VolunteerProspect } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(service: VolunteeringAreaService, util: UtilityService, domainData: DomainDataService, dialogService: DialogService, app: AppService): GridSetup<VolunteerProspect> {

	return {
		rowName: { singular: 'Potential Volunteer', plural: 'Potential Volunteers' },
		getRowKey: row => '' + row.leadVolunteerId,
		stateKey: 'potential-volunteers-grid',
		actions: getActions(service, dialogService),
		buttons: [],
		columns: getColumns(util, domainData, app),
	}
}
